<tax-page-header titleText="404"></tax-page-header>

<div class="ui-kit-block-title">Страница не найдена</div>

<div class="ui-kit-content-container">
  <div>
    <ul class="error-reasons">
      <div class="error-reasons-title">Возможные причины:</div>
      <li>неправильно набран адрес</li>
      <li>документ был удален</li>
      <li>документ был перемещен</li>
      <li>документ был переименован</li>
    </ul>
  </div>
</div>
